<template>
  <div class="manufacturers-filter position-relative">
    <i v-if="selected !== 'Select Manufacturer'" @click.self.stop="clearFilter" 
    class="fas fa-times manufacturers-filter__close-icon cursor-pointer"></i>

    <select v-model="selected" @change="changed" class="form-control">
      <option selected disabled>Select Manufacturer</option>
      <option v-for="manufacturer in manufacturers" :key="manufacturer.value" :value="manufacturer.value">
        {{manufacturer.label}}
      </option>
    </select>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        selected: null,
        category_id: this.$page.props.category_id,
        manufacturers: null
      }
    },
    props: {
      categoryRoute: String,
      shopRoute: String,
      manufacturer_id: Number
    },
    mounted() {
      this.manufacturers = this.$page.props.manufacturers_select
      this.selected = this.getManufacturer()
    },
    methods: {
      getManufacturer() {
        const manufacturer_id = this.$page.props.manufacturer_id
        if (manufacturer_id) {
          for(let i=0; i<this.manufacturers.length; i++) {
            if (Number(manufacturer_id) === Number(this.manufacturers[i].value)) {
              return this.manufacturers[i].value
            }
          }
        } else return 'Select Manufacturer'
      },
      clearFilter() {
        this.$inertia.visit(route(this.categoryRoute, {
          category: this.category_id || '', _query: this.mergeQueryParams({
            manufacturer: undefined,
            query: this.$page.props.query
          })
        }))
      },
      changed(event, manufacturer=false) {
        const queryObject = this.mergeQueryParams({
          manufacturer: manufacturer || event.target.value,
          query: this.$page.props.query
        })

        if (this.category_id) {
          this.$inertia.visit(route(this.categoryRoute, {
            category: this.category_id, _query: queryObject
          }))
        } else {
          this.$inertia.visit(route(this.shopRoute, { _query: queryObject }))
        }
      }
    },
    watch: {
      manufacturer_id() {
        this.changed(null, this.manufacturer_id)
      }
    }
  }
</script>

<style>
  .manufacturers-filter__close-icon {
    position: absolute;
    font-size: 10px;
    right: 22px;
    bottom: 13px;
    color: #495057;
    z-index: 2;
  }
</style>
